import { createFileRoute } from '@tanstack/react-router';
import { SettingsPage } from '@/features/settings/settings-page';
import { guardRoute } from '@/lib/route-guards';

export const Route = createFileRoute('/_app/admin/settings')({
  beforeLoad: ({ context }) => {
    guardRoute(context.auth, '/admin/settings');
  },
  component: SettingsPage,
});
